/**
 * Denetim kaydı görünümünün metinleri (plan M7 Task 30; ADR 0029 K37) [NR496 4.6.3]: panel
 * başlıkları, olaylar ve PMS tablolarının alan etiketleri. Etiket anahtarı kolon adıdır; aynı ad
 * her tabloda aynı anlamdadır. `locales.test.ts` her PMS kolonunun iki dilde etiketi olduğunu
 * sınar [NR496 4.1.5].
 */

export const pmsAuditEn = {
  title: 'Audit Trail',
  shipNote:
    'Only changes made on board are listed. The full field history of records prepared or changed in the office is in the office version.',
  officeHistory: 'Field history is in the office version',
  loading: 'Loading the audit trail…',
  error: 'The audit trail could not be loaded.',
  retry: 'Retry',
  empty: 'No changes recorded.',
  table: 'Audit trail',
  showing: 'Showing {{from}}-{{to}} of {{total}}',
  pagination: 'Audit trail pages',
  columns: {
    at: 'Time (UTC)',
    shipTime: 'Ship Time',
    record: 'Record',
    op: 'Change',
    field: 'Field',
    oldValue: 'Old Value',
    newValue: 'New Value',
    user: 'User',
    device: 'Computer',
    matrixVersion: 'Matrix',
  },
  ops: {
    insert: 'Created',
    update: 'Changed',
    delete: 'Removed',
    prepared_in_office: 'Prepared in office before activation',
    created_in_office: 'Created in office',
    changed_in_office: 'Changed in office',
  },
  tables: {
    equipment: 'Equipment',
    running_hour_readings: 'Running hours reading',
    job_definitions: 'Job definition',
    job_interval_changes: 'Interval change',
    work_orders: 'Work order',
    work_records: 'Work record',
    postponements: 'Postponement',
    record_voids: 'Void',
    attachments: 'Attachment',
    measurement_points: 'Measurement point',
    cm_import_batches: 'CM import',
    measurements: 'Measurement',
    defects: 'Defect',
    vessel_certificate_types: 'Certificate type',
    vessel_certificates: 'Vessel certificate',
    certificate_pages: 'Certificate page',
    vessel_surveys: 'Survey',
    class_findings: 'Class finding',
    class_item_list: 'Class item',
    ce_authorizations: 'Chief engineer authorization',
    certificate_endorsements: 'Endorsement',
    class_confirmations: 'Surveyor confirmation',
    certificate_issuances_on_board: 'Certificate issued on board',
  },
  fields: {
    acceptance_criteria: 'Acceptance criteria',
    active: 'Active',
    alert_high: 'Alert high',
    alert_low: 'Alert low',
    anniversary_date: 'Anniversary date',
    assigned_to: 'Assigned to',
    auto_defect: 'Opens defect automatically',
    auto_defect_off_reason: 'Reason automatic defect is off',
    baseline_done_hours: 'Last done (hours, previous system)',
    baseline_done_on: 'Last done (previous system)',
    baseline_original: 'Original baseline',
    baseline_taken_on: 'Baseline taken on',
    baseline_value: 'Baseline',
    bv_item_code: 'BV item code',
    cancel_reason: 'Cancellation reason',
    caption: 'Caption',
    category: 'Category',
    ce_authorization_id: 'Chief engineer authorization',
    ce_credit: 'Credited for class',
    ce_rejection_code: 'Not credited because',
    ce_survey: 'Chief engineer survey',
    alarm_test: 'Alarm test (UMS / E0)',
    certificate_id: 'Certificate',
    change_reason: 'Reason for change',
    checklist: 'Checklist',
    checklist_result: 'Checklist result',
    class_item_category: 'Class item category',
    class_item_code: 'Class item code',
    class_notification_ref: 'Class notification reference',
    class_notification_waiver: 'Class notification waiver',
    class_reference: 'Class reference',
    class_relevant: 'Class related',
    closed_on: 'Closed on',
    cm_report_pending: 'CM report awaited',
    action_required: 'Action required to rectify defect',
    hse_report_id: 'HSEQ report',
    source_work_order_id: 'Source work order',
    library_id: 'Library item',
    library_job_id: 'Library job',
    tag: 'Tag',
    actions: 'Actions',
    captain_action_on: "Master's action date",
    daily_report_id: 'Daily report',
    department: 'Department',
    procedure_review: 'Procedure review',
    rectified_on: 'Rectified on',
    system_name: 'System',
    code: 'Code',
    condition_after: 'Condition after',
    condition_before: 'Condition before',
    condition_point_ids: 'Condition points',
    confirmations: 'Confirmations',
    confirmed_on: 'Confirmed on',
    content_hash: 'Content hash',
    corrective_action: 'Corrective action',
    counter_equipment_id: 'Running hours counter',
    critical: 'Critical',
    critical_reason: 'Critical reason',
    cumulative_hours: 'Accumulated hours',
    cycle_base_record_id: 'Cycle',
    danger_high: 'Danger high',
    danger_low: 'Danger low',
    declaration_ref: 'Declaration reference',
    decommission_reason: 'Reason for removal',
    defect_id: 'Defect',
    defect_no: 'Defect no.',
    defects_opened: 'Defects opened',
    deleted_at: 'Removed at',
    description: 'Description',
    direction: 'Direction',
    done_at: 'Done at',
    done_on: 'Done on',
    draft: 'Draft',
    due_hours_at_completion: 'Due hours at completion',
    due_on: 'Due on',
    due_on_at_completion: 'Due date at completion',
    endorsed_on: 'Endorsed on',
    equipment_code: 'Equipment code',
    equipment_id: 'Equipment',
    estimated_minutes: 'Estimated minutes',
    expiry_date: 'Expiry date',
    file_key: 'File key',
    file_name: 'File name',
    file_sha256: 'File SHA-256',
    file_size: 'File size',
    first_original_due_hours: 'First original due (hours)',
    first_original_due_on: 'First original due date',
    has_counter: 'Has running hours counter',
    high_inclusive: 'High limit inclusive',
    immediate_action: 'Immediate action',
    import_batch_id: 'CM import',
    imposed_on: 'Imposed on',
    installed_on: 'Installed on',
    instruction_document_id: 'Instruction',
    instruction_missing: 'Instruction not on board',
    instruction_revision_id: 'Instruction revision',
    instruction_sha256: 'Instruction SHA-256',
    interval_basis: 'Interval basis',
    interval_every: 'Interval',
    interval_hours: 'Interval (hours)',
    interval_months: 'Interval (months)',
    interval_unit: 'Interval unit',
    investigation: 'Investigation',
    ism_relevant: 'ISM related',
    issue_date: 'Issue date',
    issued_by: 'Issued by',
    item_code: 'Item code',
    items: 'Items',
    job_definition_id: 'Job',
    job_type: 'Job type',
    kind: 'Type',
    last_done_on: 'Last done on',
    limit_source: 'Limit source',
    limits_snapshot: 'Limits at measurement',
    local_date: 'Ship date',
    location: 'Location',
    low_inclusive: 'Low limit inclusive',
    maker: 'Maker',
    manual_document_id: 'Manual',
    manual_ref: 'Manual reference',
    max_daily_hours: 'Daily hours limit',
    measured_at: 'Measured at',
    measurement_id: 'Measurement',
    measurements_added: 'Measurements added',
    meter_hours: 'Meter value',
    meter_start_hours: 'New meter start',
    mime_type: 'File type',
    mode: 'Mode',
    model: 'Model',
    name: 'Name',
    new_due_hours: 'New due (hours)',
    new_due_on: 'New due date',
    new_interval: 'New interval',
    next_due_on: 'Next due on',
    next_survey_override: 'Next survey (set by office)',
    no_repair_reason: 'Reason no repair needed',
    node_type: 'Node type',
    nominal: 'Nominal',
    noon_report_source: 'Noon Report source',
    notes: 'Notes',
    number: 'Number',
    office_decision_id: 'Office interval decision',
    on_board_issuance_id: 'Issued on board',
    operational_impact: 'Operational impact',
    out_of_pms_manual: 'Out of PMS',
    out_of_pms_reason: 'Out of PMS reason',
    overdue_reason: 'Reason for overdue',
    override_reason: 'Override reason',
    owner_id: 'Owner',
    owner_type: 'Owner type',
    parent_id: 'Parent',
    performed_by: 'Performed by',
    place: 'Place',
    planned_spare_parts: 'Planned spare parts',
    point_id: 'Measurement point',
    points_created: 'Points created',
    points_updated: 'Points updated',
    previous_due_hours: 'Previous due (hours)',
    previous_due_on: 'Previous due date',
    previous_interval: 'Previous interval',
    previous_meter_final: 'Old meter final value',
    priority: 'Priority',
    procedure: 'Procedure',
    provider: 'Provider',
    read_at: 'Read at',
    reason: 'Reason',
    record_id: 'Record',
    record_type: 'Record type',
    remarks: 'Remarks',
    renewed_from_id: 'Renewal of',
    repair_work_order_id: 'Repair work order',
    replaces_certificate_id: 'Replaces certificate',
    report: 'Report',
    report_attachment_key: 'Survey report file',
    reported_at: 'Reported at',
    requirement_refs: 'Requirements',
    responsible_role_id: 'Responsible role',
    result: 'Result',
    root_cause: 'Root cause',
    rows_total: 'Rows',
    running_hours: 'Running hours',
    safety_check: 'Safety check',
    safety_critical: 'Safety critical',
    safety_items: 'Safety items',
    serial_no: 'Serial no.',
    severity: 'Severity',
    sfi_code: 'SFI code',
    short_term: 'Short term',
    sort_order: 'Order',
    source: 'Source',
    source_id: 'Source record',
    spare_parts_used: 'Spare parts used',
    started_at: 'Started at',
    status: 'Status',
    sub_category: 'Sub-category',
    supersedes_id: 'Corrects',
    supersedes_record_id: 'Corrects record',
    survey_kind: 'Survey type',
    survey_principle: 'Survey principle',
    survey_scheme: 'Survey scheme',
    surveyor: 'Surveyor',
    target_on: 'Target date',
    technical: 'Technical data',
    test_result: 'Test result',
    text: 'Text',
    title: 'Title',
    total_hours: 'Meter value',
    type_id: 'Certificate type',
    tz_offset_min: 'Ship time offset (minutes)',
    unit: 'Unit',
    user_id: 'Person',
    valid_from: 'Valid from',
    valid_to: 'Valid to',
    value: 'Value',
    voided_content_hash: 'Voided content hash',
    window_from: 'Window from',
    window_from_override: 'Window from (set by office)',
    window_to: 'Window to',
    window_to_override: 'Window to (set by office)',
    wo_no: 'Work order no.',
    work_order_id: 'Work order',
    work_hours: 'Man-hours',
    work_performed: 'Work performed',
    work_type: 'Work type',
  },
};

export const pmsAuditTr: typeof pmsAuditEn = {
  title: 'Denetim Kaydı',
  shipNote:
    'Yalnız gemide yapılan değişiklikler listelenir. Ofiste hazırlanan ya da değiştirilen kayıtların alan geçmişi ofis sürümündedir.',
  officeHistory: 'Alan geçmişi ofis sürümündedir',
  loading: 'Denetim kaydı yükleniyor…',
  error: 'Denetim kaydı yüklenemedi.',
  retry: 'Yeniden dene',
  empty: 'Kayıtlı değişiklik yok.',
  table: 'Denetim kaydı',
  showing: '{{total}} kayıttan {{from}}-{{to}} arası',
  pagination: 'Denetim kaydı sayfaları',
  columns: {
    at: 'Zaman (UTC)',
    shipTime: 'Gemi Saati',
    record: 'Kayıt',
    op: 'Değişiklik',
    field: 'Alan',
    oldValue: 'Eski Değer',
    newValue: 'Yeni Değer',
    user: 'Kullanıcı',
    device: 'Bilgisayar',
    matrixVersion: 'Matris',
  },
  ops: {
    insert: 'Oluşturuldu',
    update: 'Değiştirildi',
    delete: 'Kayıttan kaldırıldı',
    prepared_in_office: 'Etkinleştirmeden önce ofiste hazırlandı',
    created_in_office: 'Ofiste oluşturuldu',
    changed_in_office: 'Ofiste değiştirildi',
  },
  tables: {
    equipment: 'Ekipman',
    running_hour_readings: 'Çalışma saati okuması',
    job_definitions: 'İş tanımı',
    job_interval_changes: 'Aralık değişikliği',
    work_orders: 'İş emri',
    work_records: 'İş kaydı',
    postponements: 'Erteleme',
    record_voids: 'İptal',
    attachments: 'Ek',
    measurement_points: 'Ölçüm noktası',
    cm_import_batches: 'CM içe aktarma',
    measurements: 'Ölçüm',
    defects: 'Arıza',
    vessel_certificate_types: 'Sertifika türü',
    vessel_certificates: 'Gemi sertifikası',
    certificate_pages: 'Sertifika sayfası',
    vessel_surveys: 'Sörvey',
    class_findings: 'Klas bulgusu',
    class_item_list: 'Klas kalemi',
    ce_authorizations: 'Başmühendis yetki beyanı',
    certificate_endorsements: 'Vize',
    class_confirmations: 'Sörveyör teyidi',
    certificate_issuances_on_board: 'Gemide düzenlenen sertifika',
  },
  fields: {
    acceptance_criteria: 'Kabul ölçütü',
    active: 'Etkin',
    alert_high: 'Uyarı üst sınırı',
    alert_low: 'Uyarı alt sınırı',
    anniversary_date: 'Yıl dönümü',
    assigned_to: 'Atanan',
    auto_defect: 'Arızayı kendiliğinden açar',
    auto_defect_off_reason: 'Otomatik arıza kapalılık gerekçesi',
    baseline_done_hours: 'Son yapılış (saat, önceki sistem)',
    baseline_done_on: 'Son yapılış (önceki sistem)',
    baseline_original: 'İlk baseline',
    baseline_taken_on: 'Baseline alındığı gün',
    baseline_value: 'Baseline',
    bv_item_code: 'BV kalem kodu',
    cancel_reason: 'İptal gerekçesi',
    caption: 'Açıklama',
    category: 'Kategori',
    ce_authorization_id: 'Başmühendis yetki beyanı',
    ce_credit: 'Klas için sayıldı',
    ce_rejection_code: 'Sayılmama nedeni',
    ce_survey: 'Başmühendis sörveyi',
    alarm_test: 'Alarm testi (UMS / E0)',
    certificate_id: 'Sertifika',
    change_reason: 'Değişiklik gerekçesi',
    checklist: 'Kontrol listesi',
    checklist_result: 'Kontrol listesi sonucu',
    class_item_category: 'Klas kalemi kategorisi',
    class_item_code: 'Klas kalemi kodu',
    class_notification_ref: 'Klas bildirimi referansı',
    class_notification_waiver: 'Klas bildirimi muafiyeti',
    class_reference: 'Klas referansı',
    class_relevant: 'Klasla ilgili',
    closed_on: 'Kapanış günü',
    cm_report_pending: 'CM raporu bekleniyor',
    action_required: 'Arızanın onarılması için gereken işlemler',
    hse_report_id: 'HSEQ raporu',
    source_work_order_id: 'Kaynak iş emri',
    library_id: 'Kütüphane kalemi',
    library_job_id: 'Kütüphane işi',
    tag: 'Etiket (Tag)',
    actions: 'Faaliyetler',
    captain_action_on: 'Kaptanın işlem tarihi',
    daily_report_id: 'Günlük rapor',
    department: 'Departman',
    procedure_review: 'Prosedür gözden geçirme',
    rectified_on: 'Giderilme tarihi',
    system_name: 'Sistem',
    code: 'Kod',
    condition_after: 'Sonraki durum',
    condition_before: 'Önceki durum',
    condition_point_ids: 'Ölçüm noktaları',
    confirmations: 'Onaylar',
    confirmed_on: 'Teyit günü',
    content_hash: 'İçerik hash',
    corrective_action: 'Düzeltici faaliyet',
    counter_equipment_id: 'Çalışma saati sayacı',
    critical: 'Kritik',
    critical_reason: 'Kritiklik gerekçesi',
    cumulative_hours: 'Birikmiş saat',
    cycle_base_record_id: 'Döngü',
    danger_high: 'Tehlike üst sınırı',
    danger_low: 'Tehlike alt sınırı',
    declaration_ref: 'Beyan referansı',
    decommission_reason: 'Kayıttan kaldırma gerekçesi',
    defect_id: 'Arıza',
    defect_no: 'Arıza no',
    defects_opened: 'Açılan arıza',
    deleted_at: 'Kayıttan kaldırıldığı an',
    description: 'Açıklama',
    direction: 'Yön',
    done_at: 'Yapıldığı an',
    done_on: 'Yapıldığı gün',
    draft: 'Taslak',
    due_hours_at_completion: 'Yapılıştaki vade saati',
    due_on: 'Vade',
    due_on_at_completion: 'Yapılıştaki vade',
    endorsed_on: 'Vize günü',
    equipment_code: 'Ekipman kodu',
    equipment_id: 'Ekipman',
    estimated_minutes: 'Tahmini süre (dakika)',
    expiry_date: 'Bitiş günü',
    file_key: 'Dosya anahtarı',
    file_name: 'Dosya adı',
    file_sha256: 'Dosya SHA-256',
    file_size: 'Dosya boyutu',
    first_original_due_hours: 'İlk orijinal vade (saat)',
    first_original_due_on: 'İlk orijinal vade',
    has_counter: 'Çalışma saati sayacı var',
    high_inclusive: 'Üst sınır dahil',
    immediate_action: 'Acil önlem',
    import_batch_id: 'CM içe aktarma',
    imposed_on: 'Konulduğu gün',
    installed_on: 'Kurulum günü',
    instruction_document_id: 'Talimat',
    instruction_missing: 'Talimat gemide yok',
    instruction_revision_id: 'Talimat revizyonu',
    instruction_sha256: 'Talimat SHA-256',
    interval_basis: 'Aralık dayanağı',
    interval_every: 'Aralık',
    interval_hours: 'Aralık (saat)',
    interval_months: 'Aralık (ay)',
    interval_unit: 'Aralık birimi',
    investigation: 'İnceleme',
    ism_relevant: 'ISM ile ilgili',
    issue_date: 'Düzenleme günü',
    issued_by: 'Düzenleyen',
    item_code: 'Kalem kodu',
    items: 'Kalemler',
    job_definition_id: 'İş',
    job_type: 'İş türü',
    kind: 'Tür',
    last_done_on: 'Son yapılış',
    limit_source: 'Limit kaynağı',
    limits_snapshot: 'Ölçümdeki limitler',
    local_date: 'Gemi günü',
    location: 'Konum',
    low_inclusive: 'Alt sınır dahil',
    maker: 'Üretici',
    manual_document_id: 'Manual',
    manual_ref: 'Manual referansı',
    max_daily_hours: 'Günlük saat sınırı',
    measured_at: 'Ölçüldüğü an',
    measurement_id: 'Ölçüm',
    measurements_added: 'Eklenen ölçüm',
    meter_hours: 'Sayaç değeri',
    meter_start_hours: 'Yeni sayaç başlangıcı',
    mime_type: 'Dosya türü',
    mode: 'Kip',
    model: 'Model',
    name: 'Ad',
    new_due_hours: 'Yeni vade (saat)',
    new_due_on: 'Yeni vade',
    new_interval: 'Yeni aralık',
    next_due_on: 'Sonraki vade',
    next_survey_override: 'Sonraki sörvey (ofisin girdiği)',
    no_repair_reason: 'Onarım gerekmeme gerekçesi',
    node_type: 'Düğüm türü',
    nominal: 'Nominal',
    noon_report_source: 'Noon Report kaynağı',
    notes: 'Notlar',
    number: 'Numara',
    office_decision_id: 'Ofis aralık kararı',
    on_board_issuance_id: 'Gemide düzenlenen',
    operational_impact: 'Operasyonel etki',
    out_of_pms_manual: 'PMS dışı',
    out_of_pms_reason: 'PMS dışı gerekçesi',
    overdue_reason: 'Gecikme gerekçesi',
    override_reason: 'Elle değiştirme gerekçesi',
    owner_id: 'Sahip kayıt',
    owner_type: 'Sahip türü',
    parent_id: 'Üst',
    performed_by: 'Yapan',
    place: 'Yer',
    planned_spare_parts: 'Planlanan yedek parçalar',
    point_id: 'Ölçüm noktası',
    points_created: 'Açılan nokta',
    points_updated: 'Güncellenen nokta',
    previous_due_hours: 'Önceki vade (saat)',
    previous_due_on: 'Önceki vade',
    previous_interval: 'Önceki aralık',
    previous_meter_final: 'Eski sayacın son değeri',
    priority: 'Öncelik',
    procedure: 'Prosedür',
    provider: 'Sağlayıcı',
    read_at: 'Okunduğu an',
    reason: 'Gerekçe',
    record_id: 'Kayıt',
    record_type: 'Kayıt türü',
    remarks: 'Notlar',
    renewed_from_id: 'Yenilediği sertifika',
    repair_work_order_id: 'Onarım iş emri',
    replaces_certificate_id: 'Yerine geçtiği sertifika',
    report: 'Rapor',
    report_attachment_key: 'Sörvey raporu dosyası',
    reported_at: 'Bildirildiği an',
    requirement_refs: 'Gereklilikler',
    responsible_role_id: 'Sorumlu rol',
    result: 'Sonuç',
    root_cause: 'Kök neden',
    rows_total: 'Satır',
    running_hours: 'Çalışma saati',
    safety_check: 'Güvenlik kontrolü',
    safety_critical: 'Emniyet açısından kritik',
    safety_items: 'Güvenlik maddeleri',
    serial_no: 'Seri no',
    severity: 'Önem',
    sfi_code: 'SFI kodu',
    short_term: 'Kısa süreli',
    sort_order: 'Sıra',
    source: 'Kaynak',
    source_id: 'Kaynak kayıt',
    spare_parts_used: 'Kullanılan yedek parçalar',
    started_at: 'Başladığı an',
    status: 'Durum',
    sub_category: 'Alt kategori',
    supersedes_id: 'Düzelttiği',
    supersedes_record_id: 'Düzelttiği kayıt',
    survey_kind: 'Sörvey türü',
    survey_principle: 'Sörvey prensibi',
    survey_scheme: 'Sörvey düzeni',
    surveyor: 'Sörveyör',
    target_on: 'Hedef gün',
    technical: 'Teknik bilgiler',
    test_result: 'Test sonucu',
    text: 'Metin',
    title: 'Başlık',
    total_hours: 'Sayaç değeri',
    type_id: 'Sertifika türü',
    tz_offset_min: 'Gemi saati farkı (dakika)',
    unit: 'Birim',
    user_id: 'Kişi',
    valid_from: 'Geçerlilik başı',
    valid_to: 'Geçerlilik sonu',
    value: 'Değer',
    voided_content_hash: 'İptal edilen içeriğin hash’i',
    window_from: 'Pencere başı',
    window_from_override: 'Pencere başı (ofisin girdiği)',
    window_to: 'Pencere sonu',
    window_to_override: 'Pencere sonu (ofisin girdiği)',
    wo_no: 'İş emri no',
    work_order_id: 'İş emri',
    work_hours: 'Adam-saat',
    work_performed: 'Yapılan iş',
    work_type: 'İş tipi',
  },
};
